module.exports = {
	"title": "CSS Backdrop Filter",
	"description": "Method of applying filter effects (like blur, grayscale or hue) to content/elements below the target element.",
	"spec": "http://dev.w3.org/fxtf/filters-2/#BackdropFilterProperty",
	"status": "unoff",
	"links": [
		{
			"url": "http://product.voxmedia.com/til/2015/2/17/8053347/css-ios-transparency-with-webkit-backdrop-filter",
			"title": "Blog post"
		},
		{
			"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/backdrop-filter",
			"title": "Mozilla Developer Network"
		},
		{
			"url": "https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/9160189-backdrop-filters",
			"title": "Edge feature request"
		}
	],
	"bugs": [
		{
			"description": "Chrome feature request: [Chromium issue #497522](https://code.google.com/p/chromium/issues/detail?id=497522)"
		},
		{
			"description": "Firefox feature request: [Mozilla bug #1178765](https://bugzilla.mozilla.org/show_bug.cgi?id=1178765)"
		}
	],
	"categories": [
		"CSS",
		"CSS3"
	],
	"stats": {
		"ie": {
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"5.5": "n"
		},
		"edge": {
			"12": "n",
			"13": "n",
			"14": "n"
		},
		"firefox": {
			"2": "n",
			"3": "n",
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n",
			"41": "n",
			"42": "n",
			"43": "n",
			"44": "n",
			"45": "n",
			"46": "n",
			"47": "n",
			"48": "n",
			"49": "n",
			"50": "n",
			"51": "n",
			"52": "n",
			"53": "n",
			"3.5": "n",
			"3.6": "n"
		},
		"chrome": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n",
			"41": "n",
			"42": "n",
			"43": "n",
			"44": "n",
			"45": "n",
			"46": "n",
			"47": "n d #1",
			"48": "n d #1",
			"49": "n d #1",
			"50": "n d #1",
			"51": "n d #1",
			"52": "n d #1",
			"53": "n d #1",
			"54": "n d #1",
			"55": "n d #1",
			"56": "n d #1",
			"57": "n d #1"
		},
		"safari": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "y x",
			"10": "y x",
			"3.1": "n",
			"3.2": "n",
			"5.1": "n",
			"6.1": "n",
			"7.1": "n",
			"9.1": "y x",
			"TP": "y x"
		},
		"opera": {
			"9": "n",
			"11": "n",
			"12": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n d #1",
			"35": "n d #1",
			"36": "n d #1",
			"37": "n d #1",
			"38": "n d #1",
			"39": "n d #1",
			"40": "n d #1",
			"41": "n d #1",
			"42": "n d #1",
			"43": "n d #1",
			"9.5-9.6": "n",
			"10.0-10.1": "n",
			"10.5": "n",
			"10.6": "n",
			"11.1": "n",
			"11.5": "n",
			"11.6": "n",
			"12.1": "n"
		},
		"ios_saf": {
			"8": "n",
			"10": "y x",
			"3.2": "n",
			"4.0-4.1": "n",
			"4.2-4.3": "n",
			"5.0-5.1": "n",
			"6.0-6.1": "n",
			"7.0-7.1": "n",
			"8.1-8.4": "n",
			"9.0-9.2": "y x",
			"9.3": "y x"
		},
		"op_mini": {
			"all": "n"
		},
		"android": {
			"3": "n",
			"4": "n",
			"53": "n",
			"2.1": "n",
			"2.2": "n",
			"2.3": "n",
			"4.1": "n",
			"4.2-4.3": "n",
			"4.4": "n",
			"4.4.3-4.4.4": "n"
		},
		"bb": {
			"7": "n",
			"10": "n"
		},
		"op_mob": {
			"10": "n",
			"11": "n",
			"12": "n",
			"37": "n d #1",
			"11.1": "n",
			"11.5": "n",
			"12.1": "n"
		},
		"and_chr": {
			"53": "n d #1"
		},
		"and_ff": {
			"49": "n"
		},
		"ie_mob": {
			"10": "n",
			"11": "n"
		},
		"and_uc": {
			"11": "n"
		},
		"samsung": {
			"4": "n"
		}
	},
	"notes": "",
	"notes_by_num": {
		"1": "Can be enabled via the \"Experimental Web Platform Features\" flag"
	},
	"usage_perc_y": 10.65,
	"usage_perc_a": 0,
	"ucprefix": false,
	"parent": "",
	"keywords": "blue,hue-rotate,invert,saturate,filter",
	"ie_id": "backdropfilter",
	"chrome_id": "5679432723333120",
	"firefox_id": "",
	"webkit_id": "feature-filter-effects-backdrop-filter-propery",
	"shown": true
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/features-json/css-backdrop-filter.json
 ** module id = 410
 ** module chunks = 0
 **/